import { children, JSXElement } from "solid-js"
import Flexbox from "../st-flexbox/st-flexbox";
import styles from '../st-button/st-button.module.css'

export class STButtonGroupProps {
    children: JSXElement;
    vertical?: boolean;
}

export default function ButtonGroup(props: STButtonGroupProps) {
    const content = children(() => props.children)

    return <Flexbox dir={props.vertical ? 'vertical' : 'horizontal'} middle class={styles['btn-group']} data-vertical={props.vertical ? true : undefined}>
        {content()}
    </Flexbox>
}

ButtonGroup.defaultProps = new STButtonGroupProps();
